import React, { useEffect, useState } from "react";
import { FaTimes } from 'react-icons/fa';
const SlidingDrawer = ({
  isOpen,
  onClose,
  header,
  width = 300,
  fetchData,      // async function to fetch data, returns array of any objects
  renderItem,     // function to render each item; receives (item, index)
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);

  useEffect(() => {
    if (!isOpen) return;

    setLoading(true);
    setError(null);

    fetchData()
      .then(fetchedData => {
        setData(fetchedData);
      })
      .catch(err => {
        console.error("SlidingDrawer fetch error:", err);
        setError("Failed to load data.");
      })
      .finally(() => setLoading(false));
  }, [isOpen, fetchData]);

  if (!isOpen) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        right: 0,
        width: `${width}px`,
        height: "100vh",
        backgroundColor: "#fff",
        boxShadow: "-4px 0 10px rgba(0,0,0,0.2)",
        zIndex: 10000,
        overflowY: "auto",
        transition: "transform 0.3s ease",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          padding: 16,
          borderBottom: "1px solid #ddd",
          fontWeight: "bold",
          fontSize: 16,
          flexShrink: 0,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        {header}
      <button
        onClick={onClose}
        style={{ cursor: "pointer", border: "none", fontSize: 24, lineHeight: 1 }}
        aria-label="Close"
      >
        <FaTimes />
      </button>

      </div>

      <div style={{ padding: 16, flexGrow: 1, overflowY: "auto" }}>
        {loading && <p>Loading...</p>}
        {error && <p style={{ color: "red" }}>{error}</p>}

        {!loading && !error && data.length === 0 && <p>No data available</p>}

        {!loading && !error && data.length > 0 && (
       <ul className="session-comments-list">
        {data.map((item, idx) => (
          <li
            key={idx}
            style={{
              marginBottom: 16,
              display: "block",
              backgroundColor: "#fff",
              padding: "12px 16px",
              borderRadius: 8,
              boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
              border: "1px solid #e0e0e0",
              transition: "box-shadow 0.3s ease",
              cursor: "default",
            }}
            // Optional hover effect
            onMouseEnter={(e) => {
              e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.15)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.boxShadow = "0 2px 6px rgba(0,0,0,0.1)";
            }}
          >
            {renderItem(item, idx)}
          </li>
        ))}
      </ul>

        )}
      </div>
    </div>
  );
};

export default SlidingDrawer;
